export default "__VITE_ASSET__CK4$tDkm__"